var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.89 14h-.87c-.74 0-1.34.6-1.34 1.35v.3a1.344 1.344 0 1 1-2.69 0v-.3c0-.75-.61-1.35-1.35-1.35-.74 0-1.34.6-1.34 1.35v.3a1.35 1.35 0 0 1-2.7 0v-.3c0-.75-.6-1.35-1.34-1.35-.74 0-1.35.6-1.35 1.35v.3a1.344 1.344 0 1 1-2.69 0v-.32c0-.74-.59-1.34-1.32-1.35h-.79V13c0-1.38 1.04-2.55 2.45-2.89.28-.07.57-.11.88-.11h11.12c.31 0 .6.04.88.11 1.41.34 2.45 1.51 2.45 2.89v1zM18.44 8.58c-.29-.06-.58-.08-.88-.08H6.44c-.3 0-.59.03-.88.09V7.17C5.56 5.97 6.64 5 7.98 5h8.04c1.34 0 2.42.97 2.42 2.17v1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.008h-.77c-.26 0-.5.03-.73.09v-1.55c0-.35.34-.65.75-.65s.75.3.75.65v1.46zM16.75 5.098c-.23-.07-.47-.1-.73-.1h-.77v-1.67c0-.41.34-.75.75-.75s.75.34.75.75v1.77zM12.75 5h-1.5V2.82c0-.45.34-.82.75-.82s.75.37.75.82V5zM21.25 22H2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.36v-5.02h.61v.07c0 1.34.88 2.58 2.19 2.87 1.02.24 1.99-.09 2.65-.74.38-.38 1-.39 1.38-.01.52.51 1.23.83 2.01.83.78 0 1.49-.31 2.01-.83.38-.37.99-.37 1.38.01.65.65 1.62.98 2.65.74 1.31-.29 2.19-1.53 2.19-2.87v-.05h.71v5h.36c.41 0 .75.34.75.75s-.34.75-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCake);
export default __webpack_public_path__ + "static/media/vuesax-bold-cake.5da4aefc7c3495b0c4df2639f4422eda.svg";
export { ForwardRef as ReactComponent };